import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const saveSkill = async (token: any, skillData: any) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/SaveSkill`,
      skillData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting Professional skill:", error);
    throw error;
  }
};
